module.exports = __webpack_public_path__ + "static/media/feedback-bad.95a8af7d.png";